/* src/app/module/users/add-user/add-tyre-battery-details/add-tyre-battery-details.component.scss */
.form-container {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
}
h2 {
  margin-bottom: 20px;
  font-size: 24px;
}
h3 {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.custom-upload-button {
  margin-top: 33px;
  margin-bottom: 42px;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.custom-upload-button:disabled {
  background-color: #FFD9AA;
  border: 1px solid #FFD9AA;
  cursor: not-allowed;
}
.custom-upload-button:hover:not(:disabled) {
  background-color: #e67e00;
  border: 1px solid #e67e00;
  transform: translateY(-2px);
}
.custom-upload-button .arrow {
  margin-left: 8px;
  font-size: 16px;
  transition: margin-left 0.3s ease;
}
.custom-upload-button:hover:not(:disabled) .arrow {
  margin-left: 12px;
}
::ng-deep label {
  color: var(--Gray-700, #344054);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}
::ng-deep ::placeholder {
  color: var(--Gray-900, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  color: var(--Gray-900, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
::ng-deep .ng-invalid.ng-touched {
  border-color: darkred !important;
  box-shadow: none !important;
}
::ng-deep .p-inputtext.ng-invalid.ng-touched,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-label,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-trigger {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
  margin-bottom: 4px;
}
::ng-deep .p-dropdown {
  margin-bottom: 4px;
}
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-inputtext,
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-dropdown {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep label {
  color: var(--Gray-700, #344054);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}
::ng-deep .p-dropdown {
  margin-top: 8px;
}
::ng-deep input {
  margin-top: 8px;
}
::ng-deep .formly-validation-message {
  margin-top: 4px;
  color: #e24c4c;
}
::ng-deep .p-datepicker {
  width: 300px !important;
  height: 335px !important;
  font-size: 12px;
  overflow: hidden;
}
::ng-deep .p-datepicker-group {
  flex-direction: column !important;
  width: 100% !important;
}
::ng-deep .p-datepicker-calendar {
  table-layout: fixed;
  width: 100% !important;
  font-size: 12px;
}
::ng-deep .p-datepicker td,
::ng-deep .p-datepicker th {
  padding: 0.25rem !important;
  text-align: center;
}
::ng-deep .p-datepicker-header {
  padding: 0.5rem;
  font-size: 13px;
}
/*# sourceMappingURL=add-tyre-battery-details.component-RN6TTJ5W.css.map */
